/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const logLevelSchema = z.enum(['debug', 'info', 'warn', 'warning', 'error', 'fatal']);

export const createDebugRequestSchema = z.object({
  level: logLevelSchema,
});

export type ICreateDebugRequest = z.infer<typeof createDebugRequestSchema>;
